import { FC } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Drawer, DrawerProps } from '@fuxi/eevee-ui';
import cx from './index.module.css';

type TiangongDrawerProps = DrawerProps;

export const TiangongDrawer: FC<TiangongDrawerProps> = ({ closeIcon, ...props }) => {
  return (
    <Drawer
      extra={null}
      height={'100%'}
      placement="bottom"
      closeIcon={<CloseOutlined className="c-white font-s-xl" />}
      classNames={{
        content: 'bg-transparent!',
        header: 'h-[var(--header-height)] flex-basis-56px!',
        body: cx('tiangong-drawer-body', 'p-0! bg-container'),
      }}
      {...props}
    />
  );
};
